import {
  PreviewContainer,
  PreviewControls,
  PreviewFooter,
  PreviewHeader,
} from 'modules/templateEditor/common';
import { MediaLayout } from 'modules/placements/types';
import { usePlacementSelectorContext } from 'modules/placements/context/PlacementSelectorContext';
import { useState } from 'react';
import { SegmentedControl } from 'ui/segmentedControl';
import { pxToRem } from 'utils/convert';
import { Platform, PLATFORM_OPTIONS } from '../constants';
import { Preview } from './Preview';
import { PreviewContent, PreviewPaneContainer } from './styles';

export const PreviewPane = ({
  mediaLayout: mediaLayoutOverride,
  showHeader = true,
}: {
  mediaLayout?: MediaLayout;
  showHeader?: boolean;
}) => {
  const [selectedPlatform, setSelectedPlatform] = useState(PLATFORM_OPTIONS[0].value as Platform);
  const { selectedPlacementDetails } = usePlacementSelectorContext();
  const mediaLayout =
    mediaLayoutOverride || selectedPlacementDetails?.mediaLayout || MediaLayout.TOP;

  return (
    <PreviewPaneContainer>
      <PreviewContainer data-test="template-editor-embedded-preview" isPreviewWithData={false}>
        {showHeader && <PreviewHeader />}
        <PreviewContent data-test="template-editor-embedded-preview-content">
          <Preview selectedPlatform={selectedPlatform} mediaLayout={mediaLayout} />
        </PreviewContent>
        <PreviewFooter data-test="template-editor-embedded-preview-footer">
          <PreviewControls>
            <SegmentedControl
              onSelect={setSelectedPlatform}
              optionMinWidth={pxToRem(80)}
              options={PLATFORM_OPTIONS}
              value={selectedPlatform}
            />
          </PreviewControls>
        </PreviewFooter>
      </PreviewContainer>
    </PreviewPaneContainer>
  );
};
